import React, { useCallback, useEffect, useState } from 'react';
import { adminAPI } from '../../../services/api';

const fmtDate = (s) => (s ? new Date(s).toLocaleString('tr-TR') : '—');
const fmtMoney = (n) => (n == null ? '—' : `₺${Number(n).toFixed(2)}`);

const AdminOrdersTab = () => {
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async (s) => {
    setLoading(true);
    setError('');
    try {
      const res = await adminAPI.listOrders(s || undefined);
      setOrders(res.data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(status); }, [reload, status]);

  return (
    <div className="admin-section">
      <div className="admin-section-head">
        <h2>Orders</h2>
        <select value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">All statuses</option>
          <option value="pending">Pending</option>
          <option value="success">Success</option>
          <option value="failed">Failed</option>
        </select>
      </div>

      {error && <div className="admin-error">{error}</div>}
      {loading ? (
        <div className="admin-empty">Loading…</div>
      ) : orders.length === 0 ? (
        <div className="admin-empty">No orders to show.</div>
      ) : (
        <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Date</th>
              <th>User</th>
              <th>Plan</th>
              <th>Amount</th>
              <th>Billing address</th>
              <th>Status</th>
              <th>Iyzico ID</th>
              <th>Error</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id}>
                <td>{o.id}</td>
                <td>{fmtDate(o.created_at)}</td>
                <td>
                  {o.user_name || '—'}
                  <div className="admin-row-sub">{o.user_email}</div>
                </td>
                <td>{o.plan_name || o.plan_type || '—'}</td>
                <td>{fmtMoney(o.amount)}</td>
                <td className="admin-address-cell">
                  {o.address ? (
                    <>
                      <div>{[o.address.first_name, o.address.last_name].filter(Boolean).join(' ')}</div>
                      <div className="admin-row-sub">{o.address.address_line}</div>
                      <div className="admin-row-sub">
                        {[o.address.city, o.address.zip_code, o.address.country].filter(Boolean).join(', ')}
                      </div>
                      {o.address.phone && <div className="admin-row-sub">{o.address.phone}</div>}
                    </>
                  ) : '—'}
                </td>
                <td>
                  <span className={`admin-pill admin-pill-${o.status}`}>{o.status}</span>
                </td>
                <td className="admin-mono">{o.iyzico_payment_id || '—'}</td>
                <td className="admin-error-cell">{o.error_message || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </div>
  );
};

export default AdminOrdersTab;
